export default __webpack_public_path__ + "img/b4e81e68241b7801dc3de1ffa7bbb342.png";